export default function getWebEnv() {
	// A runtime response is authoritative, including settings left unset there.
	if (window.env) return window.env;
	if (process.env.NODE_ENV === 'production') return {};
	return {
		REACT_APP_CONTRACT_SIGN_URL: process.env.REACT_APP_CONTRACT_SIGN_URL,
		REACT_APP_SETTINGS_KEY: process.env.REACT_APP_SETTINGS_KEY,
		REACT_APP_DATA_KEY: process.env.REACT_APP_DATA_KEY,
		REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
	};
}
